export default __webpack_public_path__ + "static/media/contact_us.73f8e96a.svg";